import { render } from "./g_json.vue?vue&type=template&id=aaa389ee&scoped=true"
import script from "./g_json.vue?vue&type=script&lang=js"
export * from "./g_json.vue?vue&type=script&lang=js"

import "./g_json.vue?vue&type=style&index=0&id=aaa389ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa389ee"]])

export default __exports__